import Footer from '@/components/ui/Footer';
import Flex from '@/components/ui/Flex';
import BuyButton from '@/components/PurchasePage/OrderSummary/BuyButton';
import { useTotals } from '@/hooks/useTotals';
import { Button } from '@/components/ui/Button';
import { useNavigate } from 'react-router';

export default function OrderSummaryFooter() {
  const totals = useTotals();
  const navigate = useNavigate();
  return (
    <Footer height="116px">
      <Flex.Col gap="2" className="justify-end w-full h-full">
        <Flex.Row className="justify-between text-xl font-bold">
          <span>Total</span>
          <Flex.Row gap="2">
            {totals.isDiscounted && (
              <div className="text-muted line-through">
                <span className="font-normal">{totals.subtotalPriceText}</span>
              </div>
            )}
            <div>{totals.totalPriceText} </div>
          </Flex.Row>
        </Flex.Row>
        {totals.subtotalPrice > 0 ? (
          <BuyButton />
        ) : (
          <Button onClick={() => navigate('/proxies/buy')}>Change plan</Button>
        )}
      </Flex.Col>
    </Footer>
  );
}
